// C:\Users\USER\bookfete\frontend\src\components\common\ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    // Un lien avec ancre (ex. /how-it-works#faq) doit amener JUSQU'A cette section : on cible l'element de l'ancre s'il existe.
    if (hash) {
      const cible = document.getElementById(hash.slice(1));
      if (cible) {
        cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }

    // Arrivee sur une page : en haut, IMMEDIATEMENT (2026-10-29). Le defilement anime partait du bas de la page precedente et
    // s'arretait a mi-hauteur pendant que la nouvelle page s'affichait (« quand je clique sur FAQ je dois arriver en haut »).
    // `key` change a chaque clic, meme vers la page ou l'on est deja : cliquer « FAQ » depuis le bas de la FAQ remonte aussi.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash, key]);

  return null;
};

export default ScrollToTop;
